import React, {useCallback, useEffect} from 'react'
import View from './view'
import {Helmet} from 'react-helmet'
import {useAppDispatch} from '../../../redux/configureStore'
import {useAuth} from '../../../components/AuthProvider'
import {trackProgress} from '../../../redux/videos'
import {toggleErrorDialog} from '../../../redux/config'
import {useParams} from 'react-router-dom'
import {useSelector} from 'react-redux'
import {selectMemberAccess} from '../../../redux/members'
import {getLessons, selectLesson} from '../../../redux/lessons'
import {
  clearReplayState,
  getWorkshopReplay,
  selectWorkshopReplay,
  selectWorkshopReplayGroup,
} from '../../../redux/workshopReplay'
import Cookies from 'universal-cookie'

const WorkshopReplayPage = () => {
  const {workshopReplayId} = useParams()
  const auth = useAuth()
  const dispatch = useAppDispatch()

  const access = useSelector(selectMemberAccess)
  const lessonPlan = useSelector(selectLesson)
  const replay = useSelector(selectWorkshopReplay)
  const replayGroup = useSelector(selectWorkshopReplayGroup)

  const hasAccess =
    access && Object.keys(access).length !== 0
      ? Number(access.are?.workshops?.value) === 1
      : false

  const clearReplay = async () => {
    await dispatch(clearReplayState())
  }

  const handleUpdate = async (videoId: string, percent: number) => {
    await dispatch(
      trackProgress({
        auth,
        videoId,
        ts: percent,
        lessonPlanId: lessonPlan?.id,
      }),
    )
  }

  const loadReplay = useCallback(async () => {
    try {
      if (hasAccess && workshopReplayId) {
        const {payload, type} = await dispatch(
          getWorkshopReplay({auth, workshopReplayId}),
        )
        if (type === getWorkshopReplay.rejected.type) {
          throw new Error('Unable to get replay')
        } else if (type === getWorkshopReplay.fulfilled.type) {
          const lessonId = payload.replay.lessonPlanId
          const lessonData = await dispatch(getLessons({auth, lessonId}))

          if (lessonData.type === getLessons.rejected.type) {
            throw new Error('Unable to get lessons')
          }
        }
      }
    } catch (e) {
      await dispatch(
        toggleErrorDialog({
          opened: true,
          error:
            'We were unable to load the replay, please retry reloading the page. If issues persist contact our support team',
        }),
      )
    }
  }, [dispatch, workshopReplayId])

  const cookies = new Cookies()

  useEffect(() => {
    loadReplay()

    if (cookies.get('bks-autoplay') === undefined) {
      cookies.set('bks-autoplay', true, {
        path: '/',
      })
    }

    return () => {
      clearReplay()
    }
  }, [loadReplay])

  return (
    <>
      {replay && (
        <Helmet>
          <title>{`${replay?.title} | Black Spectacles`}</title>
        </Helmet>
      )}
      <View
        workshopReplayId={workshopReplayId!}
        replay={replay}
        group={replayGroup}
        lessonPlan={lessonPlan}
        hasAccess={hasAccess}
        onUpdate={handleUpdate}
      />
    </>
  )
}

export default WorkshopReplayPage
